 //export const api_server =''
// export const api_server = 'https://accessibilitydev.codemantra.com'
//  export const api_server ='https://aiqa.codemantra.com'
//export const api_server ='https://accessibilityuat.codemantra.com'
export const api_server ='https://accessibilityai.codemantra.com'
